import { render, staticRenderFns } from "./BcList.vue?vue&type=template&id=7956a68e"
import script from "./BcList.vue?vue&type=script&lang=js"
export * from "./BcList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports